import { R as REGEX } from './regex--pvoxsXk.js';

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

export { validate as v };
//# sourceMappingURL=validate-Cjp0GNxG.js.map
